import { bootstrap } from './app/bootstrap'

bootstrap().catch((error: unknown) => {
  console.error('[IVUS] application bootstrap failed', error)
  const root = document.querySelector('#app')
  if (root) {
    root.innerHTML = '<div class="bootstrap-error">应用启动失败，请刷新页面或联系管理员。</div>'
  }
})
